import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InviteLink } from '../../../lib/interfaces/company';
import { CustomRegisterFormService } from '../../../service/custom-register-form.service';
import { EditUserGatesComponent } from '../edit-user-gates/edit-user-gates.component';

@Component({
  selector: 'app-edit-login-forms',
  standalone: false,
  templateUrl: './edit-login-forms.component.html',
  styleUrl: './edit-login-forms.component.scss'
})
export class EditLoginFormsComponent {
    public data = inject < { inviteLink: InviteLink | null; customLoginFormConfigData: unknown[] | null }>(MAT_DIALOG_DATA);

    protected loginForm: unknown[] = [];

    private customRegisterFormService = inject(CustomRegisterFormService);
    private readonly dialogRef = inject(MatDialogRef<EditUserGatesComponent>);

    public async ngOnInit(): Promise<void> {
        if (!this.customRegisterFormService.defaultConfig.length) {
            await this.customRegisterFormService.getDefaultConfig();
        }

        if (
            (
                this.data.inviteLink?.loginForm &&
                this.data.inviteLink?.customLoginFormData
            ) ||
            this.data.customLoginFormConfigData?.length
        ) {
            this.loginForm = <unknown[]> (this.data.inviteLink!.customLoginFormData ?? this.data.customLoginFormConfigData);
        }
    }

    protected createLoginForm(): void {
        this.loginForm = JSON.parse(JSON.stringify(this.customRegisterFormService.defaultConfig));
    }

    protected async deleteLoginForm(): Promise<void> {
        let success = false;

        if (this.data.inviteLink) {
            if (!this.data.inviteLink.loginForm) {
                success = true;
            } else {
                this.data.inviteLink.loginForm = false;
                this.data.inviteLink.customLoginFormData = null;
            }
        }

        if (success) {
            this.loginForm.length = 0;
        }
    }

    protected close(): void {
        this.dialogRef.close();
    }

    public async save(): Promise<void> {
        if (!this.loginForm.length) {
            return;
        }

        this.dialogRef.close(this.loginForm);
    }
}
